<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;width: 100%;min-width:1050px">
      <el-form :inline="true">
        <el-form-item>
          <el-button icon="el-icon-arrow-left" circle @click="goBack" v-if="pid.length>1"></el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="rules" style="width: 100%;min-width:1050px" stripe row-key="id">
      <el-table-column prop="id" label="ID" width="85px" align="center" key="0"></el-table-column>
      <el-table-column prop="name" label="名称" align="left" key="1">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getRulesList(scope.row.id,scope.row.pid)"
          >{{scope.row.name}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="pname" label="上级菜单" align="center" key="2"></el-table-column>
      <el-table-column prop="url" label="URL" key="3"></el-table-column>
      <el-table-column prop="sort" label="排序" align="center" key="4"></el-table-column>
      <el-table-column prop="hide" label="隐藏" align="center" key="5">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="editRules(scope.row,'hide')"
          >{{scope.row.hide=='1'?'是':'否'}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" key="6">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="editRules(scope.row,'status')"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" key="7">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="editRules(scope.row,'type')"
          >{{scope.row.type=='1'?'权限':'菜单'}}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" key="8" min-width="180px">
        <template slot-scope="scope">
        	<el-button size="mini" v-if="scope.row.type=='1'" type="primary" @click="handleDistribution(scope.row)">分配</el-button>
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="editRules(scope.row,'delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--新增/编辑菜单窗口-->
    <el-dialog :title="winTitle" :visible.sync="winAdd" :close-on-click-modal="false" width="400px">
      <el-form ref="form" :model="form" label-width="80px" label-position="top">
        <el-form-item label="标题">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="form.url"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="是否隐藏">
          <el-radio v-model="form.hide" label="1">是</el-radio>
          <el-radio v-model="form.hide" label="0">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addCancle">取消</el-button>
        <el-button type="primary" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>
    
    <el-dialog  :visible.sync="editDialog" :close-on-click-modal="false" width="400px">
    	<el-form ref="form2" :model="form2" label-width="80px" label-position="top">
    		<el-checkbox-group v-model="form2.group_ids">
			    <el-checkbox :label="item.id" :key="item.id" v-for="item in groupList">{{item.title}}</el-checkbox>

			  </el-checkbox-group>
    	</el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click.native="editDialog=false">取消</el-button>
		    <el-button type="primary" @click.native="addDistribution">提交</el-button>
      </div>
    
    </el-dialog>
    
  </section>
</template>

<script>
import util from "../../common/js/util";
import Sortable from "sortablejs";
import {
	getGroups,
	postDistribution,
  getRuleList, //获取菜单组列表
  editRule, //编辑菜单规则(禁用之类的状态值)
  addRule, //新增菜单
  changeRule, //编辑菜单
  changeSort //批量排序菜单
} from "../../api/api";

export default {
  data() {
    return {
      rules: [], //用户组列表
      groupList:[],
      pid: [], //上一级菜单id
      id: 0, //当前属于哪一层

      form: { pid: 0, name: "", url: "", sort: "0", hide: "0" },
      form2:{
      	rule_id:'',
      	group_ids:[],
      	
      },
      

      isAdd: true, //是否为新增窗口
      winAdd: false, //是否打开编辑窗口
      editDialog:false,
    };
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13&&that.winAdd) {
          that.addSubmit();
        return false;
      }
    };
  },
  methods: {
  	handleDistribution(s){
  		 this.form2={
      	rule_id:s.id,
      	group_ids:[],
      }
  		this.editDialog=true;

  	},
    //获取规则列表
    getRulesList(id, pid, isEdit) {
      this.id = id;
      if (!isEdit) {
        this.pid.push(pid);
      }
      getRuleList(id, this.$cookie.getCookie("login")).then(res => {
        if (res.data.code == 200) {
          this.rules = res.data.data;
        } else {
          this.$message.error("网络请求失败");
        }
      });
    },
    goBack() {
      this.id = this.pid[this.pid.length - 1];
      getRuleList(
        this.pid[this.pid.length - 1],
        this.$cookie.getCookie("login")
      ).then(res => {
        if (res.data.code == 200) {
          this.rules = res.data.data;
          if (this.pid.length > 1) {
            this.pid.pop();
          }
        } else {
          this.$message.error("网络请求失败");
        }
      });
    },
    //新增菜单
    handleAdd() {
      this.winAdd = true;
      this.isAdd = true;
    },
    //编辑菜单
    handleEdit(s) {
      this.isAdd = false;
      this.form = {
        rule_id: s.id,
        name: s.name,
        url: s.url,
        sort: s.sort,
        hide: s.hide
      };
      this.winAdd = true;
    },
    addCancle() {
      this.winAdd = false;
      this.form = { pid: 0, name: "", url: "", sort: "0", hide: "0" };
    },
    addDistribution(){
    	this.form2.group_ids = this.form2.group_ids.toString();
      postDistribution(this.form2, this.$cookie.getCookie("login")).then(res => {
        if (res.data.code == 200) {
        	this.editDialog=false;
          this.$message({ message: "权限分配成功", type: "success" });
        } else {
        	this.editDialog=false;
          this.$message.error("网络请求失败");
        }
      });
    },
    addSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            this.form.pid = this.id;
            addRule(this.form, this.$cookie.getCookie("login")).then(res => {
              if (res.data.code == 200) {
                this.getRulesList(this.id, 0, true);
                this.winAdd = false;
                this.form = { pid: 0, name: "", url: "", sort: "0", hide: "0" };
                this.$message({ message: "新增菜单成功", type: "success" });
              } else {
                this.$message.error("网络请求失败");
              }
            });
          } else {
            changeRule(this.form, this.$cookie.getCookie("login")).then(res => {
              if (res.data.code == 200) {
                this.getRulesList(this.id, 0, true);
                this.winAdd = false;
                this.form = { name: "", url: "", sort: "0", hide: "0" };
                this.$message({ message: "编辑菜单成功", type: "success" });
              } else {
                this.$message.error("网络请求失败");
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    //编辑菜单状态.隐藏.类型.删除
    editRules(data, type) {
      var p = {};
      p.rule_id = data.id;
      if (type == "delete") {
        p.status = "-1";
      } else {
        p[type] = data[type] == "0" ? "1" : "0";
      }
      editRule(p, this.$cookie.getCookie("login")).then(res => {
        if (res.data.code == 200) {
          this.getRulesList(data.pid, 0, true);
          if (type == "delete") {
            this.$message({ message: "删除成功", type: "success" });
          }
        } else {
          this.$message.error("网络请求失败");
        }
      });
    },

    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.rules.splice(oldIndex, 1)[0];
          _this.rules.splice(newIndex, 0, currRow);
          var rule_id = [];
          var sort = [];
          _this.rules.forEach((v, i) => {
            rule_id.push(v.id);
            sort.push(i + 1);
          });
          var p = {
            rule_id: rule_id.join(","),
            sort: sort.join(",")
          };
          changeSort(p, _this.$cookie.getCookie("login")).then(res => {
            _this.getRulesList(_this.id, 0, true);
          });
        }
      });
    },
    getGroupsList:function(){
    	getGroups(this.$cookie.getCookie("login")).then(res => {
            this.groupList=res.data.data
          });
    }
  },
  mounted() {
    this.getRulesList(0, 0);
    this.getGroupsList();
    this.rowDrop();
  },
  computed: {
    winTitle() {
      return this.isAdd ? "新增后台菜单" : "编辑后台菜单";
    }
  }
};
</script>

<style scoped>
.toolbar .el-form-item {
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// Rules.vue?0957f31e